import React from "react";
import "./CFTCFuturesPositioning.scss";
import Table1 from "./Table1";
import Table2 from "./Table2";
import { Bar } from "react-chartjs-2-old";

import { API, graphqlOperation } from "aws-amplify";
import Loading from "../../_shared/components/Loading/Loading";
const rowFields = [
  {
    key: "sp500index",
    label: "S&P 500 (Index)",
  },
  {
    key: "russell2000emini",
    label: "Russell 2000 E-Mini",
  },
  {
    key: "vix",
    label: "VIX",
  },
  {
    key: "dowjonesmini",
    label: "Dow Jones Mini",
  },
  {
    key: "nasdaqmini",
    label: "Nasdaq Mini",
  },
  {
    key: "eurodollar",
    label: "Eurodollar",
  },
  {
    key: "a30dfedfunds",
    label: "30D Fed Funds",
  },
  {
    key: "a2yrust",
    label: "2Yr UST",
  },
  {
    key: "a5yrust",
    label: "5Yr UST",
  },
  {
    key: "a10yrust",
    label: "10Yr UST",
  },
  {
    key: "a30yrustlongbond",
    label: "30Yr UST (Long Bond)",
  },
  {
    key: "a30yrustultralongbond",
    label: "30Yr UST (Ultra Long Bond)",
  },
  {
    key: "a30yrustlongultralong",
    label: "30Yr UST (Long + Ultra Long)",
  },
  {
    key: "usd",
    label: "USD",
  },
  {
    key: "euro",
    label: "EUR",
  },
  {
    key: "jpy",
    label: "JPY",
  },
  {
    key: "gbp",
    label: "GBP",
  },
  {
    key: "aud",
    label: "AUD",
  },
  {
    key: "cad",
    label: "CAD",
  },
  {
    key: "chf",
    label: "CHF",
  },
  {
    key: "nzd",
    label: "NZD",
  },
  {
    key: "mxn",
    label: "MXN",
  },
  {
    key: "brl",
    label: "BRL",
  },
  {
    key: "rub",
    label: "RUB",
  },
  {
    key: "zar",
    label: "ZAR",
  },
  {
    key: "crudeoil",
    label: "Crude Oil",
  },
  {
    key: "naturalgas",
    label: "Natural Gas",
  },
  {
    key: "rbobgasoline",
    label: "RBOB Gasoline",
  },
  {
    key: "ulsdheatingoil",
    label: "ULSD Heating Oil",
  },
  {
    key: "gold",
    label: "Gold",
  },
  {
    key: "silver",
    label: "Silver",
  },
  {
    key: "platinum",
    label: "Platinum",
  },
  {
    key: "palladium",
    label: "Palladium",
  },
  {
    key: "copper",
    label: "Copper",
  },
  {
    key: "steel",
    label: "Steel",
  },
  {
    key: "corn",
    label: "Corn",
  },
  {
    key: "soybeans",
    label: "Soybeans",
  },
  {
    key: "wheat",
    label: "Wheat",
  },
  {
    key: "sugar",
    label: "Sugar",
  },
  {
    key: "cotton",
    label: "Cotton",
  },
  {
    key: "cocoa",
    label: "Cocoa",
  },
  {
    key: "coffee",
    label: "Coffee",
  },
  {
    key: "livecattle",
    label: "Live Cattle",
  },
  {
    key: "leanhogs",
    label: "Lean Hogs",
  },
];

export default function CFTCFuturesPositioning(props) {
  const [isLoading, setIsLoading] = React.useState(true);
  const [tableData, setTableData] = React.useState({ table1: [], table2: [] });
  const [handler, setHandler] = React.useState("");

  React.useEffect(() => {
    const handling = (e) => setHandler({ matches: e.matches });
    window
      .matchMedia("(max-width: 480px)")
      .addEventListener("change", handling);
  }, [handler]);

  React.useEffect(() => {
    refresh();
  }, []);

  React.useEffect(() => {
    if (props.reload) {
      setTableData({ table1: [], table2: [] });
      refresh();
    }
  }, [props.reload]);

  const refresh = async () => {
    const data = (
      await API.graphql(graphqlOperation(`{ get_cftc_data { data } }`))
    ).data.get_cftc_data.data;

    const zScoreDivergence1ySorted = Object.entries(data["1yzscore"])
      .filter((val) => {
        if (!isNaN(val[1])) {
          val[1] = val[1]?.toFixed(2);
          return val;
        }
        return null;
      })
      .sort(([, a], [, b]) => a - b)
      .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});

    const zScoreDivergence3ySorted = Object.entries(data["3yzscore"])
      .filter((val) => {
        if (!isNaN(val[1])) {
          val[1] = val[1]?.toFixed(2);
          return val;
        }
        return null;
      })
      .sort(([, a], [, b]) => a - b)
      .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});

    const displayLabel = (data) => {
      const label = Object.entries(data)
        .slice(0, 5)
        .concat(Object.entries(data).reverse().slice(0, 5))
        .map((obj, index) => {
          if (
            rowFields.filter((innerObj) => innerObj.key === obj[0]).length > 0
          )
            return rowFields.filter((innerObj) => innerObj.key === obj[0])[0]
              .label;
          return null;
        });

      return label;
    };

    const chartBarColor = [];
    const chartBarColor2 = [];

    setTableData({
      table1: rowFields.map((obj, index) => {
        let assetClass = "";
        if (obj.label === "S&P 500 (Index)") assetClass = "EQUITIES";
        if (obj.label === "Eurodollar") assetClass = "FIXED INCOME";
        if (obj.label === "USD") assetClass = "CURRENCIES";
        if (obj.label === "Crude Oil") assetClass = "COMMODITIES";
        return {
          assetClass: assetClass,
          market: obj.label,
          currentPositioning: data["current"][obj.key],
          wwchg: data["1w"][obj.key],
          mmchg: data["1m"][obj.key],
          threeMchg: data["3m"][obj.key],
          sixMchg: data["6m"][obj.key],
          oneYchg: data["1y"][obj.key],
          min: data["min"][obj.key],
          max: data["max"][obj.key],
          oneYW: data["1yzscore"][obj.key],
          threeYW: data["3yzscore"][obj.key],
          ticker: data["dictionary"][obj.key],
        };
      }),
      table2: rowFields.map((obj, index) => {
        return {
          number: index + 1,
          market: obj.label,
          oneYZScore: data["1yzscore"][obj.key],
          market2: obj.label,
          threeYZScore: data["3yzscore"][obj.key],
        };
      }),
      data1: {
        labels: displayLabel(zScoreDivergence1ySorted),
        datasets: [
          {
            data: Object.entries(zScoreDivergence1ySorted)
              .slice(0, 5)
              .concat(
                Object.entries(zScoreDivergence1ySorted).reverse().slice(0, 5),
              )
              .map((obj, index) => {
                if (obj[1] < 0) chartBarColor.push("#D33541");
                else chartBarColor.push("#5ec72e");
                return obj[1];
              }),
            backgroundColor: chartBarColor,
            barPercentage: 1.1,
          },
        ],
      },
      data2: {
        labels: displayLabel(zScoreDivergence3ySorted),
        datasets: [
          {
            data: Object.entries(zScoreDivergence3ySorted)
              .slice(0, 5)
              .concat(
                Object.entries(zScoreDivergence3ySorted).reverse().slice(0, 5),
              )
              .map((obj, index) => {
                if (obj[1] < 0) chartBarColor2.push("#D33541");
                else chartBarColor2.push("#5ec72e");
                return obj[1];
              }),
            backgroundColor: chartBarColor2,
            barPercentage: 1.1,
          },
        ],
      },
    });
    setIsLoading(false);
  };

  if (isLoading) return <Loading />;
  return (
    <div>
      <div className="dashboard-content">
        <div className="cftc-futures-positioning">
          <div className="section futures-positioning">
            {tableData.table1.length > 0 && <Table1 data={tableData.table1} />}
          </div>
          <div className="section z-scores">
            {tableData.table2.length > 0 && <Table2 data={tableData.table2} />}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          <div
            className="bar-charts"
            style={{
              width: window.matchMedia("(max-width: 480px)").matches
                ? "100%"
                : "50%",
              minWidth: window.matchMedia("(max-width: 480px)").matches
                ? 250
                : 380,
            }}
          >
            <div className="section">
              <div className="chart-title">1Y Z-Score Divergences</div>
              {tableData.data1 && (
                <Bar
                  data={tableData.data1}
                  options={{
                    legend: { display: false },
                    scales: {
                      x: {
                        color: "#bbb8b8",
                        ticks: {
                          font: {
                            family: "capsule",
                          },
                        },
                      },
                      y: {
                        color: "#bbb8b8",
                        ticks: {
                          font: {
                            family: "capsule",
                          },
                        },
                      },
                    },
                  }}
                />
              )}
            </div>
          </div>
          <div
            className="bar-charts"
            style={{
              width: window.matchMedia("(max-width: 480px)").matches
                ? "100%"
                : "50%",
              minWidth: window.matchMedia("(max-width: 480px)").matches
                ? 250
                : 380,
            }}
          >
            <div className="section">
              <div className="chart-title">3Y Z-Score Divergences</div>
              {tableData.data2 && (
                <Bar
                  data={tableData.data2}
                  options={{
                    legend: { display: false },
                    scales: {
                      x: {
                        color: "#bbb8b8",
                        ticks: {
                          font: {
                            family: "capsule",
                          },
                        },
                      },
                      y: {
                        color: "#bbb8b8",
                        ticks: {
                          font: {
                            family: "capsule",
                          },
                        },
                      },
                    },
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
